import { BlackJackSeatInfo, BlackJackRoomInfo } from './black_table_data';
const { ccclass, property } = cc._decorator;
import PokerTableBaseView from "../../../table/module/poker_table/poker_table_base_view";
import PokerTablePokerBase from "../../../table/module/poker_table/poker_table_poker_base";
import BlackJackTableSeatView from "./blackjack_table_seat_view";
import BlackJackTableBetView from './blackjack_table_bet_view';
import Utility from '../../../../utility/utility';
import BlackjackTableSideView from './blackjack_table_side_view';
import { BlackJack } from '../../net/proto/proto_blackjack_game';
import BlackJackUtility from '../../Utility/blackJack_utility';
import BlackjackSliderView from './blackjack_slider_view';
import BlackjackBankerView from './blackjack_banker_view';
import GameServer from '../../../hall/server/gameserver/game_server';
import { Card, CardNameIndex, CardColor } from '../../../table/module/poker_table/poker_table_common';
import ModelData from '../../../public/model_data';
import AppData from '../../../public/const/app_data';

// import GameTaskBtn from "../../../hall/module/gameTask/gameTaskBtn";

@ccclass
export default class BlackJackTableView extends PokerTableBaseView {
    

    @property(cc.Button)
    minBtn: cc.Button = null;

    @property(cc.Label)
    minBtnTxt: cc.Label = null;

    @property(cc.Button)
    maxBtn: cc.Button = null;

    @property(cc.Label)
    roomIdTxt: cc.Label = null;

    @property(cc.Label)
    roomIdMaxTxt: cc.Label = null;

    @property(cc.Label)
    maxBtnTxt: cc.Label = null;

    @property(cc.Button)
    betBtn: cc.Button = null;

    @property(cc.Node)
    bankPos: cc.Node = null;

    @property(cc.Label)
    bankPointTxt: cc.Label = null;

    @property(cc.Node)
    pointNode: cc.Node = null;

    @property(cc.Node)
    bankcollectPos: cc.Node = null;
    
 

    @property(cc.Button)
    skipBtn: cc.Button = null;
    
    @property(cc.Button)
    continueBetBtn: cc.Button = null;

    @property(cc.Button)
    continuePlayBtn: cc.Button = null;

    @property(cc.Button)
    completeBetBtn: cc.Button = null;

    @property(cc.Button)
    fenpaiBtn: cc.Button = null;

    @property(cc.Button)
    doubleBtn: cc.Button = null;

    @property(cc.Button)
    stopBtn: cc.Button = null;

    @property(cc.Button)
    wantBtn: cc.Button = null;

   

    @property(cc.Node)
    bankePointState: cc.Node = null;

    @property(cc.Button)
    buyBtn: cc.Button = null;

    @property(cc.Button)
    notBuyBtn: cc.Button = null;

    @property(BlackJackTableSeatView)//玩家座位信息预制
    seatViewPrefab: BlackJackTableSeatView = null

    @property(PokerTablePokerBase)//poker预制
    pokerPrefab: PokerTablePokerBase = null


    @property(BlackJackTableBetView)//玩家下注预制
    betViewPrefab: BlackJackTableSeatView = null

    @property(BlackjackSliderView)//滑动条
    sliderView: BlackjackSliderView = null

    @property([cc.Node])//玩家下注父节点
    nodeBetParentList: cc.Node[] = []

    @property(cc.Node)//筹码
    chipPrefab: cc.Node=null

    @property(BlackjackTableSideView)//旁注
    sideView: BlackjackTableSideView=null

    @property(BlackjackBankerView)//庄家手势
    bankerView: BlackjackBankerView=null
    
    @property(cc.Node)//btn父节点
    buttons: cc.Node=null
    
    @property(cc.Node)//保险提示背景
    insuranceBg: cc.Node=null
    
    @property(cc.Label)//保险提示文字
    insuranceTxt: cc.Label=null

    @property(cc.Node)//发牌起始位置
    pokerStartNode: cc.Node=null
    
    @property(cc.Node)//所有筹码的总节点
    chipPos: cc.Node=null

    @property(cc.Node)//根据芒果场合金币场显示
    chipBoxBg: cc.Node=null


    @property(cc.Button)//所有筹码的总节点
    moreBtn: cc.Button=null



    isPlayingSelectPokerAnim: boolean;
    pokers: PokerTablePokerBase[] = []

    private roomInfo:BlackJackRoomInfo=null;
    
    myPlayerSeatInfo:BlackJackSeatInfo=null
    public allBetViewList:BlackJackTableBetView[]=[]
    public allSeatViewList:BlackJackTableSeatView[]=[]
    bankPokerList:PokerTablePokerBase[]=[]
    
    
    
    
    m_customGetSpriteFrameKeyFunc: Function;
    
    orderSeatList:number[]=[]
    emojiMap:{[playerId:number] : cc.Node} = {};
    //==============================================================

    
    onLoad(){
        
        super.onLoad()
        this.showNetPrompt(false)
        
        this.buttonReconnect.node.on('click', function () {
            GameServer.instance.heartbeat_timeout_reconnect()
        }, this)
        this.buttonReconnect.node.active=AppData.testMode
    }
    onShow() {
        super.onShow()
    }
    resetView(){
        this.buttons.active=false;
    }
    initAllSeatViews()
    {   
        cc.log("initAllSeatViews------------------------------")
       
        cc.log("this.nodeSeatParentList"+this.nodeSeatParentList.length)
        let seatPosNodeList = this.nodeSeatParentList
        for (let index = 0; index < seatPosNodeList.length; index++) 
        {
            const element = seatPosNodeList[index];
            let nodeSeat = super.instantiateObj(this.seatViewPrefab.node, element)
            let seatView = nodeSeat.getComponent<BlackJackTableSeatView>(BlackJackTableSeatView)
            seatView.node.active=false
            seatView.setBlackJackTableView(this)
            seatView.setParentPos(element)
            seatView.reset()
            this.allSeatViewList.push(seatView)

            const parent = this.nodeBetParentList[index];
            let nodeBet = super.instantiateObj(this.betViewPrefab.node, parent)
            let betView = nodeBet.getComponent<BlackJackTableBetView>(BlackJackTableBetView)
            betView.buttons.active=false
            betView.setBlackJackTableView(this)
            betView.setParentPos(parent)
            
            this.allBetViewList.push(betView)
        }
        cc.log("allBetViewList"+this.allBetViewList.length)
        this.resetSeatViewPos()
    }
    resetSeatViewPos()
    {
        
    }
    showSeatInfo()
    {
        cc.log("showSeatInfo")
    }
    showSeatCoinBalance()
    {
        cc.log("showSeatCoinBalance")
    }
    getBetViewByPos(num:number)
    {
        for(let i=0;i<this.allBetViewList.length;i++)
        {
            // if(this.allBetViewList[i].posInfo==null)
            // {
            //     continue
            // }
            if(this.allBetViewList[i].seatNo==num)
            {
                return this.allBetViewList[i]
            }  
        }
        return null;   
    }
    getSeatView(pos:number)
    {
        for(let i=0;i<this.allSeatViewList.length;i++)
        {
            // if(this.allSeatViewList[i].posInfo==null)
            // {
            //     continue
            // }
            if(this.allSeatViewList[i].seatNo==pos)
            {
                return this.allSeatViewList[i]
            }
        }
        return null;  
    }
    getSeatViewById(id:number|Long)
    {
        for(let i=0;i<this.allSeatViewList.length;i++)
        {
            if(this.allSeatViewList[i].posInfo==null)
            {
                continue
            }
            if(this.allSeatViewList[i].posInfo.playerId==id &&this.allSeatViewList[i].posInfo.isMainSeat)
            {
                return this.allSeatViewList[i]
            } 
        }
        return null;  
    }
    getSeatNodeById(playerId:number)
    {
        this.emojiMap=[]
        for(let i=0;i<this.allSeatViewList.length;i++)
        {
            if(this.allSeatViewList[i].posInfo==null)
            {
                continue
            }
            if(this.allSeatViewList[i].posInfo.playerId==playerId && this.allSeatViewList[i].posInfo.isMainSeat)
            {
                return this.allSeatViewList[i].node.parent
            }
        }
        return null
    }
    hideBetViewLight() {
        for(let i=0;i<this.allBetViewList.length;i++)
        {
            this.allBetViewList[i].lightsRest()
            this.allBetViewList[i].showSideBetBtn()
        }
    }
    clearReason(reason:number)
    {
        for(let i=0;i<this.allBetViewList.length;i++)
        {
            if(this.allBetViewList[i].posInfoArr.length>0)
            {
                this.allBetViewList[i].clearReason(reason);
            }
        }
    }
    
   

    
    getSeatIndexSequence():number[]{
        let sequence = []
        let seatCount = this.getSeatCount()
        for (let index = 0; index < seatCount; index++) {            
            sequence.push(index)
        }
        return sequence
    }
    getPokerSpriteKeyByCode(code: number){
        let card = Card.makeCardByCode(code)
        if(card.index == CardNameIndex.card_big_king){
            return 'Public_大王'
        }
        if(card.index == CardNameIndex.card_small_king){
            return 'Public_小王'
        }
        let key = 'Public_'        
        switch(card.color){
            case CardColor.color_black_heart:
                key += 'heitao_'
                break
            case CardColor.color_red_heart:
                key += 'hongtao_'
                break
            case CardColor.color_plum:
                key += 'meihua_'
                break
            case CardColor.color_square:
                key += 'fangkuai_'
                break
        }
        return key + card.index
    }
    
    getRoomInfo()
    {
        return this.roomInfo;
    }
    //已经下注完 底注 完美对子，21_+3
    mySeatCompleteBet()
    {
        
        Utility.setBtnGray(this.betBtn,true)
        Utility.setBtnGray(this.minBtn,true)
        Utility.setBtnGray(this.maxBtn,true)
        Utility.setBtnGray(this.skipBtn,true)
        
        this.showEmptyBet();
        //Utility.setNodeGray(this.skipBtn.node,true)
    }
    //下注完成后 显示空位 可占位下注
    showEmptyBet()
    {
        
        for(let i=0;i<this.allBetViewList.length;i++)
        {
            if(this.allBetViewList[i].buttons.active==false)
            {
                this.allBetViewList[i].buttons.active=true;
                this.allBetViewList[i].showNotice(true,"Bet");
            }
        }
    }
    hideEmptyBet()
    {
        for(let i=0;i<this.allBetViewList.length;i++)
        {
            if(this.allBetViewList[i].otherBet.active==true)
            {
                this.allBetViewList[i].buttons.active=false;
                this.allBetViewList[i].showNotice(false);
            }
        }
    }
    initTable() 
    {
        
        this.sliderView.showPanel(false)
        let betView:BlackJackTableBetView=null
        let seatView:BlackJackTableSeatView=null
        for(let i=0;i<this.allBetViewList.length;i++)
        {
            betView=this.allBetViewList[i]
            
            betView.reset();
            seatView=this.allSeatViewList[i]
            seatView.clearNoMainPosInfo()
            seatView.showResult(false);
            seatView.showState("",false)
        }
        this.bankerView.reset()
        
        
        this.bankPokerList=[];
        //删除isMangoTable的判断  modif by dred 
        this.chipBoxBg.getChildByName("chipBox2").active=false
        this.chipBoxBg.getChildByName("chipBox").active=true
    }
    removeViewPlayer() {
        for(let i=0;i<this.allSeatViewList.length;i++)
        {
            let betView=this.allBetViewList[i]
            this.allSeatViewList[i].posInfo=null  
            betView.posInfoArr.length=0
            
            betView.reset();
            this.allSeatViewList[i].showPanel()
        }
    }
    getPokerEndPos(betPos:number,betView:BlackJackTableBetView)
    {
        let pos:cc.Vec2
        if(betPos>5)
        {
            pos=BlackJackUtility.getConvertToNodeSpaceAR(this.pokerStartNode,betView.rightPokerPos)
        }
        else
        {
            if(betView.posInfoArr.length==1)
            {
                pos=BlackJackUtility.getConvertToNodeSpaceAR(this.pokerStartNode,betView.pokerPos)
            }
            else
            {
                pos=BlackJackUtility.getConvertToNodeSpaceAR(this.pokerStartNode,betView.leftPokerPos)
            }
        }
        return pos
    }
    getPokerParent(betPos:number,betView:BlackJackTableBetView)
    {
        let parentNode:cc.Node=null
        if(betPos>5)
        {
            parentNode=betView.rightPokerPos
        }
        else
        {
            if(betView.posInfoArr.length==1)
            {
                parentNode=betView.pokerPos
            }
            else
            {
                parentNode=betView.leftPokerPos
            }
        }
        return parentNode
    }
    hideSeatMask()
    {
        for(let i=0;i<this.allSeatViewList.length;i++)
        {
            this.allSeatViewList[i].checkMask()
        }
    }
    hideSeatState() {
        for(let i=0;i<this.allSeatViewList.length;i++)
        {
            this.allSeatViewList[i].showState("",false)
        }
    }
}

// protected formatLeftTime(leftTime: number): string{
    //     let result = ""
    //     var days = Math.floor(leftTime / 60 / 60 / 24); //计算剩余的天数 
    //     var hours = Math.floor(leftTime / 60 / 60 % 24); //计算剩余的小时 
    //     var minutes = Math.floor(leftTime / 60 % 60);//计算剩余的分钟 
    //     var seconds = Math.floor(leftTime % 60);//计算剩余的秒数           
    //     if(days > 1){
    //         return `${days}天${hours}小时`
    //     }else if(hours > 1){
    //         return `${hours}小时${minutes}分`
    //     }else if(minutes > 1){
    //         return `${minutes}分${seconds}秒`
    //     }else if(seconds >= 0){
    //         return `${seconds}秒`
    //     }
    //     return result
    // }

